import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CardBodyComponent } from './components/card-body/card-body.component';
import { CardFooterComponent } from './components/card-footer/card-footer.component';
import { CardHeaderComponent } from './components/card-header/card-header.component';
import { CardImgOverlayComponent } from './components/card-img-overlay/card-img-overlay.component';
import { CardComponent } from './components/card/card.component';
import { CardImageDirective } from './directives/card-image.directive';

/** Component declaration and export array  */
const COMPONENTS: unknown[] = [
  CardComponent,
  CardBodyComponent,
  CardHeaderComponent,
  CardFooterComponent,
  CardImageDirective,
  CardImgOverlayComponent,
];

/**
 * Card module
 */
@NgModule({
  declarations: [COMPONENTS],
  imports: [CommonModule],
  exports: [COMPONENTS],
})
export class CardModule {}
